export enum SolicitorNotificationTagEnum {
  new_update = "NEW_UPDATE",
  action_required = "ACTION_REQUIRED",
  no_update = "NO_UPDATE",
}
